import {Injectable} from "@angular/core";
import {ProtobufService} from "../protobuf.service";
import {map} from "rxjs/operators";
import {GetInvoiceAttachmentResponse, GetInvoicesResponse, Invoice} from "@proto/odoo/invoice";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  private readonly baseUrl = '/services/invoices';

  constructor(private protoService: ProtobufService) {}

  public getInvoices(offset?: number): Observable<Invoice[]> {
    const params = offset && offset > 0 ? '?offset='+offset : '';
    return this.protoService.get(this.baseUrl + params).pipe(
      map(response => {
        if (response) {
          return GetInvoicesResponse.decode(response).invoices;
        }
      })
    )
  }

  public getInvoiceAttachments(invoiceId: number, attachmentId: number): Observable<GetInvoiceAttachmentResponse> {
    return this.protoService.get(`${this.baseUrl}/${invoiceId}/attachments/${attachmentId}`).pipe(
      map(response => {
        if (response) {
          return GetInvoiceAttachmentResponse.decode(response);
        }
      })
    )
  }

}